import React from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./ui/AdminApp";
import { LandingApp } from "./ui/LandingApp";
import "./styles/main.css";

const root = createRoot(document.getElementById("root")!);
const isAdmin = location.pathname.startsWith("/admin");
root.render(<React.StrictMode>{isAdmin ? <AdminApp /> : <LandingApp />}</React.StrictMode>);
